/**
 * Created by Mikhail Menshenin on 04.09.2024
 */

const VillageAttackControlView = cc.Node.extend({
    ctor: function (village) {
        this._super();

        const styles = cleverapps.styles.VillageAttackControlView;
        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize(styles);

        const controlPanelBg = cleverapps.UI.createScale9Sprite(bundles.village.frames.control_panel_bg);
        controlPanelBg.setContentSize(styles);
        controlPanelBg.setPosition(this.width / 2, this.height / 2);
        this.addChild(controlPanelBg);

        const player = village.getPlayer();
        const avatar = this.avatar = new cleverapps.UI.Avatar(player);
        avatar.setAlignment(styles.avatar);
        avatar.setScale(styles.avatar.scale);
        this.addChild(avatar);

        const nameText = cleverapps.UI.generateOnlyText(Messages.get("VillageAttackScene.playerVillage", { name: player.name }), cleverapps.styles.FONTS.ATTACK_NAME_TEXT);
        nameText.setAlignment(styles.name);
        this.addChild(nameText);

        const revengeButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_red,
            width: styles.revenge.width,
            height: styles.revenge.height,
            content: new TextWithIcon(`** ${Messages.get("VillageAttackScene.revenge")}`, {
                icons: {
                    "**": bundles.village.frames.revenge_icon
                },
                iconScale: 1.5
            }),
            onClicked: function () { }
        });
        revengeButton.setAlignment(styles.revenge);
        this.addChild(revengeButton);

        const friendsButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            width: styles.friends.width,
            height: styles.friends.height,
            content: new TextWithIcon(`** ${Messages.get("VillageAttackScene.friends")}`, {
                icons: {
                    "**": bundles.village.frames.friends_icon
                },
                iconScale: 1.5
            }),
            onClicked: function () { }
        });
        friendsButton.setAlignment(styles.friends);
        this.addChild(friendsButton);

        village.on("assault", this.hide.bind(this), this);
        village.on("defense", this.hide.bind(this), this);
    },

    show: function () {
        const position = this.getPosition();
        this.setPosition(position.x, position.y + this.height);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            new cc.MoveBy(0.4, 0, -this.height).easing(cc.easeOut(1))
        ));
    },

    hide: function () {
        this.runAction(new cc.Sequence(
            new cc.MoveBy(0.4, 0, this.height).easing(cc.easeIn(1))
        ));
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ATTACK_NAME_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.VillageAttackControlView = {
    width: 512,
    height: 200,

    padding: {
        x: 100
    },

    avatar: {
        x: { align: "left", dx: 20 },
        y: { align: "bottom", dy: 24 },

        scale: 1,

        padding: {
            x: 10,
            top: 8,
            bottom: 12
        }
    },

    name: {
        x: { align: "left", dx: 152 },
        y: { align: "center", dy: 20 }
    },

    revenge: {
        width: 160,
        height: 60,
        x: { align: "right", dx: -20 },
        y: { align: "bottom", dy: 20 }
    },

    friends: {
        width: 160,
        height: 60,
        x: { align: "right", dx: -200 },
        y: { align: "bottom", dy: 20 }
    }
};